import { Component, OnInit, Input, Inject, OnDestroy } from "@angular/core";

import { ProjectConfiguration } from "../../../project/models/project-configuration";
import { MonitoringBehaviorSubjectService } from "../../services/monitoring-behavior-subject.service";
import { Subscription } from "rxjs";
import { MonitoredTrain } from "../../models/monitored-train";


const ALARM_LEVELS = {
    1: {
        color: "#D6F6FF",
        label: "I18N_FILTER.INFORMATIONAL",
        level: 1,
        checked: true
    },
    2: {
        color: "#FFFF00",
        label: "I18N_FILTER.LOW_SEVERITY",
        level: 2,
        checked: true
    },
    3: {
        color: "#rgb(255, 180, 0)",
        label: "I18N_FILTER.MEDIUM_SEVERITY",
        level: 3,
        checked: true
    },
    4: {
        color: "#FF3333",
        label: "I18N_FILTER.HIGH_SEVERITY",
        level: 4,
        checked: true
    },
    5: {
        color: "red",
        label: "I18N_FILTER.FATAL_SEVERITY",
        level: 5,
        checked: true
    },
    7: {
        color: "945ABF",
        label: "I18N_FILTER.TRAIN_FAILURE",
        level: 7,
        checked: true
    }
}

const REMOVE_FILTER = {
  alarmKeyword: undefined,
  alarmLevels: [],
  alarmACKStatuses: [],
  maintainers: [],
  serviceIds: [],
  connectivityServers: [],
  telemetryServers: [],
  inCommercialServiceTrips: false,
  openedForServiceTrips: false,
  outsideDepot: false,
  trainTypes: [],
  autoRefresh: true
};

const DEFAULT_FILTER_VISIBILITY_STATE = {
  searchForAlarm: true,
  trainStatus: true,
  alarmSeverity: true,
  inCommercialServiceTrips: true,
  openedForServiceTrips: true,
  outsideDepot: true,
  trainType: true,
  maintainers: true,
  maintenanceBoxes: false, // TODO Is it still used?
  currentService: true,
  nextService: true,
  connServer: true,
  teleServer: true,
  showOfflineScheduledTrains: false
};

@Component({
  selector: "app-fault-filters",
  template: require('./fault-filters.component.html'),
  styles: [require('./fault-filters.component.sass')]
})
export class FaultFiltersComponent implements OnInit, OnDestroy {
  @Input() projectId: number;
  @Input() projectConfiguration: ProjectConfiguration;

  actualTrains: any[];
  customTrainTypeNames: any[];

  maintainersObjects: any[];
  trainTypeObjects: any[];
  currentServiceIdsObjects: any[];
  nextServiceIdsObjects: any[];
  connServerObjects: any[];
  teleServerObjects: any[];

  maintainers: any[];
  trainTypes: any[];
  currentServiceIds: any[];
  nextServiceIds: any[];
  connectivityServers: any[];
  telemetryServers: any[];

  alarmKeyword: string;
  alarmLevels: any[];
  alarmACKStatuses: any[];
  inCommercialServiceTrips = false;
  openedForServiceTrips = false;
  outsideDepot = false;
  autoRefresh = true;

  checkedServiceId: any;

  filtersConfig = DEFAULT_FILTER_VISIBILITY_STATE;

  // subscriptions
  monitoringDataSubscription: Subscription;

  constructor(
    @Inject("MonitoringStoreService") private monitoringStoreService: any,
    @Inject("TrainTypeService") private trainTypeService: any,
    @Inject("FilterStorage") private filterStorage: any,
    private monitoringBehaviorSubjectService: MonitoringBehaviorSubjectService
  ) {
    this.monitoringDataSubscription = this.monitoringBehaviorSubjectService.changeOccured.subscribe(
      data => {
        if (data) {
          switch (data.action) {
            case "trains-updated":
              
              this.getTrainsData(this.projectId);
              break;
            case 'reload-trains':
              this.resetFilters([
                'maintainers', 'trainTypes', 'currentServiceIds', 'nextServiceIds'
              ])
            break;
          }
        }
      }
    );
  }

  ngOnInit() {
    this.filtersConfig = (this.projectConfiguration && this.projectConfiguration.alarmFiltersConfiguration) || DEFAULT_FILTER_VISIBILITY_STATE;
    const filterValues = localStorage.getItem(`monitoring-filters-${this.projectId}`);
    const activeFilters = filterValues ? JSON.parse(filterValues) : REMOVE_FILTER;
    this.applyFilters(activeFilters);
  }


  applyFilters(activeFilters) {
    this.autoRefresh = activeFilters.autoRefresh;
    this.alarmKeyword = activeFilters.alarmKeyword;
    this.alarmLevels = activeFilters.alarmLevels;
    this.alarmACKStatuses = activeFilters.alarmACKStatuses;
    this.inCommercialServiceTrips = activeFilters.inCommercialServiceTrips;
    this.openedForServiceTrips = activeFilters.openedForServiceTrips;
    this.outsideDepot = activeFilters.outsideDepot;
    this.trainTypes =  activeFilters.trainTypes;
    this.maintainers =  activeFilters.maintainers;
    this.currentServiceIds = activeFilters.currentServiceIds;
    this.nextServiceIds = activeFilters.nextServiceIds;
    this.connectivityServers = activeFilters.connectivityServers;
    this.telemetryServers = activeFilters.telemetryServers;
    this.monitoringStoreService.setFilters(activeFilters);
  }

  updateFilters() {    
    const currentFilters = this.preprocessFilters();
    this.monitoringStoreService.setFilters(currentFilters);
  }

  
  getTrainsData(projectId) {
   const unfilteredTrains: MonitoredTrain[] = this.monitoringStoreService.getUnfilteredTrains(
      projectId
    );
    this.processFetchedTrains(unfilteredTrains);
    const actualTrains = this.monitoringStoreService.getTrains(projectId);
    this.updateTrainCounters(actualTrains);
  }

  resetFilters(filtersToRemove?: string[]) {
    if (filtersToRemove) {
      let filterValues: any = localStorage.getItem(`monitoring-filters-${this.projectId}`);
      if (filterValues) {
        filterValues = JSON.parse(filterValues);
        for (let index = 0; index < filtersToRemove.length; index++) {
          const filter = filtersToRemove[index];
          filterValues[filter] = [];
        }
        this.initFilter(filterValues);
      } 
    } else {
      localStorage.removeItem(`monitoring-filters-${this.projectId}`);
      this.initFilter(REMOVE_FILTER);
    }
    this.updateFilters();
  }

  /*
 FUNCTIONS
 */

 searchAlarmByKeyword = () => {
    this.updateFilters();
 }

  adjustServiceFilter() {
    this.currentServiceIds =  this.currentServiceIds && this.currentServiceIds.map(function(serviceId) {
      serviceId.checked = true;
      return serviceId;
    });
    this.nextServiceIds = this.nextServiceIds && this.nextServiceIds.map(function(serviceId) {
      serviceId.checked = true;
      return serviceId;
    });
    this.updateFilters();
  }

  onTrainAlarmACKStatusChanged = (selectedStatus) => {
   this.alarmACKStatuses = this.alarmACKStatuses.map(status => {
      if (status.background === selectedStatus.background) {
        status.checked = !status.checked;
      }
      return status;
    })
    this.updateFilters();
  }

  onAlarmSeverityChanged = (item) => {
    this.alarmLevels = this.alarmLevels.map(level => {
        if (level.level === item.level) {
            level.checked = !level.checked;
        }
        return level;
    })
    this.updateFilters();
  }

  adjustRefreshCheckbox() {
    this.updateFilters();
  }

  updateTrainCounters(actualTrains) {
    this.alarmLevels = this.alarmLevels && this.alarmLevels.map(alarmLevel => {
      return {
        ...alarmLevel,
        count: 0 
      };
    });

    this.trainTypeObjects = this.trainTypeObjects && this.trainTypeObjects.map(function(
      trainTypeObject
    ) {
      trainTypeObject.count = 0;
      trainTypeObject.nameWithCount = trainTypeObject.name;
      return trainTypeObject;
    });

    this.maintainersObjects = this.maintainersObjects && this.maintainersObjects.map(function(
      maintainerObject
    ) {
      maintainerObject.count = 0;
      maintainerObject.nameWithCount = maintainerObject.name;
      return maintainerObject;
    });

    this.currentServiceIdsObjects = this.currentServiceIdsObjects && this.currentServiceIdsObjects.map(function(
      serviceIdObject
    ) {
      serviceIdObject.count = 0;
      serviceIdObject.nameWithCount = serviceIdObject.name;
      return serviceIdObject;
    });

    this.nextServiceIdsObjects = this.nextServiceIdsObjects && this.nextServiceIdsObjects.map(function(
      serviceIdObject
    ) {
      serviceIdObject.count = 0;
      serviceIdObject.nameWithCount = serviceIdObject.name;
      return serviceIdObject;
    });

    this.connServerObjects = this.connServerObjects && this.connServerObjects.map(function(
      connServerObj
    ) {
      connServerObj.count = 0;
      connServerObj.nameWithCount = connServerObj.name;
      return connServerObj;
    });

    this.teleServerObjects = this.teleServerObjects && this.teleServerObjects.map(function(
      teleServerObj
    ) {
      teleServerObj.count = 0;
      teleServerObj.nameWithCount = teleServerObj.name;
      return teleServerObj;
    });

    actualTrains.forEach(train => {
      if (!train.currentTrip) {
        train.currentTrip = {};
        train.currentTrip.tripId = "no-service";
      }

      if (!train.nextTrip) {
        train.nextTrip = {};
        train.nextTrip.tripId = "no-service";
      }
      let matchedAlarmLevels = this.alarmLevels.reduce((acc, alarmLevel) => {
        acc[alarmLevel.level] = !!train.issues.find(issue => issue.severity === alarmLevel.level);
        return acc;
      }, {});

      this.alarmLevels = this.alarmLevels.map(alarmLevel => {
        alarmLevel.count += matchedAlarmLevels[alarmLevel.level] ? 1 : 0;
        return alarmLevel;
      })



      let trainTypeString = train.trainType;
      let indexTrainType = this.trainTypeObjects.findIndex(trainType => {
        let trainTypeObject = this.trainTypeService.createTrainTypeObject(
          trainTypeString
        );
        return trainType.name === trainTypeObject.name;
      });
      if (indexTrainType > -1) {
        this.trainTypeObjects[indexTrainType].count += 1;
        this.trainTypeObjects[indexTrainType].nameWithCount =
          this.trainTypeObjects[indexTrainType].name +
          " (" +
          this.trainTypeObjects[indexTrainType].count +
          ")";
      }

      let currentMaintainer = train.projectName
        ? train.projectName + "-" + train.maintainer
        : train.maintainer;
      let indexMaintainer = this.maintainersObjects.findIndex(maintainer => {
        return maintainer.name === currentMaintainer;
      });
      if (indexMaintainer > -1) {
        this.maintainersObjects[indexMaintainer].count += 1;
        this.maintainersObjects[indexMaintainer].nameWithCount =
          this.maintainersObjects[indexMaintainer].name +
          " (" +
          this.maintainersObjects[indexMaintainer].count +
          ")";
      }

      const currentServiceId = train.currentTrip && train.currentTrip.tripId;
      let indexCurrentServiceId = this.currentServiceIdsObjects.findIndex(service => {
        return (
          service.name === currentServiceId
        );
      });
      if (indexCurrentServiceId > -1) {
        this.currentServiceIdsObjects[indexCurrentServiceId].count += 1;
        this.currentServiceIdsObjects[indexCurrentServiceId].nameWithCount =
          this.currentServiceIdsObjects[indexCurrentServiceId].name +
          " (" +
          this.currentServiceIdsObjects[indexCurrentServiceId].count +
          ")";
      }


      const nextServiceId = train.nextTrip && train.nextTrip.tripId;
      let indexNextServiceId = this.nextServiceIdsObjects.findIndex(service => {
        return service.name === nextServiceId;
      });
      if (indexNextServiceId > -1) {
        this.nextServiceIdsObjects[indexNextServiceId].count += 1;
        this.nextServiceIdsObjects[indexNextServiceId].nameWithCount =
          this.nextServiceIdsObjects[indexNextServiceId].name +
          " (" +
          this.nextServiceIdsObjects[indexNextServiceId].count +
          ")";
      }

      if (this.connServerObjects) {
        let indexConnSrvr = this.connServerObjects.findIndex(connServer => {
          return connServer.name === train.connectivityServer;
        });
        if (indexConnSrvr > -1) {
          this.connServerObjects[indexConnSrvr].count += 1;
          this.connServerObjects[indexConnSrvr].nameWithCount =
            this.connServerObjects[indexConnSrvr].name +
            " (" +
            this.connServerObjects[indexConnSrvr].count +
            ")";
        }
      }

      if (this.teleServerObjects) {
        let indexTeleSrvr = this.teleServerObjects.findIndex(teleServer => {
          return teleServer.name === train.telemetryServer;
        });
        if (indexTeleSrvr > -1) {
          this.teleServerObjects[indexTeleSrvr].count += 1;
          this.teleServerObjects[indexTeleSrvr].nameWithCount =
            this.teleServerObjects[indexTeleSrvr].name +
            " (" +
            this.teleServerObjects[indexTeleSrvr].count +
            ")";
        }
      }
    });
  }

  processFetchedTrains = (fetchedTrains: MonitoredTrain[]) => {
    
    const filterValues = localStorage.getItem(`monitoring-filters-${this.projectId}`);
    const activeFilters = filterValues ? JSON.parse(filterValues) : REMOVE_FILTER;

    this.customTrainTypeNames = this.trainTypeService.getTrainTypeDisplayNameObjects(
      fetchedTrains
    );
    let minOfficialId = Number.POSITIVE_INFINITY;
    let maxOfficialId = -1;
    const trainTypeEntities = {};
    const trainTypeObjectEntities = {};
    const maintainerEntities = {};
    const serviceIdEntities = {
      current: {},
      next: {}
    };
    const alarmLevelsEntities: any = ALARM_LEVELS;
    const trainStatuses = {};
    const connServerEntities = {};
    const teleServerEntities = {};
    for (let index = 0; index < fetchedTrains.length; index++) {
      const train = fetchedTrains[index];
      if (minOfficialId > train.officialId) {
        minOfficialId = train.officialId;
      }
      if (maxOfficialId < train.officialId) {
        maxOfficialId = train.officialId;
      }

      if (
        trainStatuses[train.alarmAckStyle["background-color"]] === undefined
      ) {
        let description = "";
        let id = -1;
        switch (train.alarmAckStyle["background-color"]) {
          case "LIME":
          case "GREEN":
            description = "I18N_FILTER.NO_ALARMS";
            id = 1;
            break;
          case "YELLOW":
            description = "I18N_FILTER.ACKED_ALARMS";
            id = 2;
            break;
          case "RED":
            description = "I18N_FILTER.ACTIVE_ALARMS";
            id = 3;
            break;
          case "GREY":
            description = "I18N_FILTER.OFFLINE_10_MINUTES";
            id = 4;
            break;
          case "BLACK":
            description = "I18N_FILTER.OFFLINE_48_HOURS";
            id = 5;
            break;
        }

        trainStatuses[train.alarmAckStyle["background-color"]] = {
          background: train.alarmAckStyle["background-color"],
          color: train.alarmAckStyle["color"],
          description: description,
          id: id
        };
      }

      if (train.severity > 0 && !alarmLevelsEntities[train.severity]) {
        alarmLevelsEntities[train.severity] = {
          ...ALARM_LEVELS[train.severity]
        };
      }
      

      if (!train.currentTrip) {
        train.currentTrip = {
          tripId: train.projectName ? train.projectName + "-" + "no-service" : "no-service"
        };
      } 
      
      const trainCurrentTripId = train.projectName
      ? train.projectName + "-" + train.currentTrip &&
        train.currentTrip.tripId
      : train.currentTrip && train.currentTrip.tripId;
      if (
        trainCurrentTripId &&
        !serviceIdEntities["current"][trainCurrentTripId]
      ) {
        serviceIdEntities["current"][trainCurrentTripId] = {
          name: trainCurrentTripId
        };
      }

      if (!train.nextTrip) {
        train.nextTrip = {
          tripId: train.projectName
            ? train.projectName + "-" + "no-service"
            : "no-service"
        };
      } 

      const trainNextTripId = train.projectName
      ? train.projectName + "-" + train.nextTrip && train.nextTrip.tripId
      : train.nextTrip && train.nextTrip.tripId;
    if (trainNextTripId && !serviceIdEntities["next"][trainNextTripId]) {
      serviceIdEntities["next"][trainNextTripId] = {
        name: trainNextTripId
      };
    
    }

      let trainTypeString = train.trainType;
      if (trainTypeString && !trainTypeEntities[trainTypeString]) {
        trainTypeEntities[trainTypeString] = true;
        let trainTypeObject = this.trainTypeService.createTrainTypeObject(
          trainTypeString
        );
        let trainTypeName = trainTypeObject.name;
        if (trainTypeName) {
          trainTypeObjectEntities[trainTypeName] = Object.assign(
            {},
            trainTypeObject,
            { checked: true }
          );
        }
      }

      let trainMaintainer = train.projectName
        ? train.projectName + "-" + train.maintainer
        : train.maintainer;
      if (trainMaintainer) {
        if (!maintainerEntities[trainMaintainer]) {
          maintainerEntities[trainMaintainer] = {
            name: trainMaintainer
          };

        }
      }

      let trainConnServer = train.connectivityServer;
      if (trainConnServer) {
        if (!connServerEntities[trainConnServer]) {
          connServerEntities[trainConnServer] = {
            name: trainConnServer
          }
        }
      }
  
      let trainTeleServer = train.telemetryServer;
      if (trainTeleServer) {
        if (!teleServerEntities[trainTeleServer]) {
          teleServerEntities[trainTeleServer] = {
            name: trainTeleServer
          }
        }
      }
    }


    this.alarmACKStatuses = Object.keys(trainStatuses).map(background => {       
      return {
        ...trainStatuses[background],
        checked: activeFilters.alarmACKStatuses && !!activeFilters.alarmACKStatuses.find(alarmBackground => alarmBackground === background)
      };
    });

    this.alarmLevels = Object.keys(alarmLevelsEntities).map(level => {
      return {
        ...alarmLevelsEntities[level],
        checked: activeFilters.alarmLevels && !!activeFilters.alarmLevels.find(alarmLevel => alarmLevel === parseInt(level))
      }
    });

    this.trainTypeObjects = Object.keys(trainTypeObjectEntities).map(type => {
      return {
        ...trainTypeObjectEntities[type],
        checked: activeFilters.trainTypes && !!activeFilters.trainTypes.find(trainType => trainType === type)
      }
    });

    this.maintainersObjects = Object.keys(maintainerEntities).map(maintainerKey => {
      return {
        ...maintainerEntities[maintainerKey],
        checked: activeFilters.maintainers && !!activeFilters.maintainers.find(maintainer => maintainer === maintainerKey)
      }
    });

    this.currentServiceIdsObjects =  Object.keys(serviceIdEntities['current']).map(serviceId => {
      return {
        ...serviceIdEntities['current'][serviceId]
      }   
    });

    this.nextServiceIdsObjects =  Object.keys(serviceIdEntities['next']).map(serviceId => {
      return {
        ...serviceIdEntities['next'][serviceId]
      }   
    });


    this.connServerObjects = Object.keys(connServerEntities).map((connSrvrKey) => {
       return {
         ...connServerEntities[connSrvrKey],
         checked: activeFilters.connectivityServers && !!activeFilters.connectivityServers.find(server => server === connSrvrKey)
       }
    });

    this.teleServerObjects = Object.keys(teleServerEntities).map((teleSrvrKey) =>{ 
        return {
          ...teleServerEntities[teleSrvrKey],
          checked: activeFilters.telemetryServers && !!activeFilters.telemetryServers.find(server => server === teleSrvrKey)
        };
      });

  };

  initFilter(filter) {
    this.autoRefresh = filter ? filter.autoRefresh : this.autoRefresh;
    this.alarmKeyword = filter && filter.alarmKeyword || null;
    this.inCommercialServiceTrips = filter
      ? filter.inCommercialServiceTrips
      : this.inCommercialServiceTrips;
    this.openedForServiceTrips = filter
      ? filter.openedForServiceTrips
      : this.openedForServiceTrips;
    this.outsideDepot = filter ? filter.outsideDepot : this.outsideDepot;

    this.maintainers = this.maintainersObjects && this.maintainersObjects.filter(function(
      maintainerObject
    ) {
      return filter && filter.maintainers
        ? !!filter.maintainers.find(function(maintainer) {
            return maintainer === maintainerObject.name;
          })
        : false;
    });

    let serviceIds = filter && filter.serviceIds;
    let currentServiceIdsObjects = this.currentServiceIdsObjects && this.currentServiceIdsObjects.filter(function(
      serviceIdObject
    ) {
      return serviceIdObject.category === "current";
    });

    this.currentServiceIds = currentServiceIdsObjects && currentServiceIdsObjects
      .filter(function(serviceIdObject) {
        let currentServiceIds =
          serviceIds &&
          serviceIds.filter(function(serviceId) {
            return serviceId.category === "current";
          });
        return currentServiceIds
          ? !!currentServiceIds.find(function(service) {
              return service.serviceId === serviceIdObject.name;
            })
          : false;
      })
      .map(function(serviceId) {
        serviceId.checked = true;
        return serviceId;
      });

    let nextServiceIdsObjects = this.nextServiceIdsObjects && this.nextServiceIdsObjects.filter(function(
      serviceIdObject
    ) {
      return serviceIdObject.category === "next";
    });

    this.nextServiceIds = nextServiceIdsObjects && nextServiceIdsObjects
      .filter(function(serviceIdObject) {
        let nextServiceIds =
          serviceIds &&
          serviceIds.filter(function(serviceId) {
            return serviceId.category === "next";
          });
        return nextServiceIds
          ? !!nextServiceIds.find(function(service) {
              return service.serviceId === serviceIdObject.name;
            })
          : false;
      })
      .map(function(serviceId) {
        serviceId.checked = true;
        return serviceId;
      });

    if (this.connServerObjects) {
      this.connectivityServers = this.connServerObjects.filter(function(
        connServerObj
      ) {
        return filter && filter.connectivityServers
          ? !!filter.connectivityServers.find(function(connServer) {
              return connServer === connServerObj.name;
            })
          : false;
      });
    }

    if (this.teleServerObjects) {
      this.telemetryServers = this.teleServerObjects.filter(function(
        teleServerObj
      ) {
        return filter && filter.telemetryServers
          ? !!filter.telemetryServers.find(function(teleServer) {
              return teleServer === teleServerObj.name;
            })
          : false;
      });
    }

    this.alarmLevels = this.alarmLevels && this.alarmLevels.map(function(alarmLevel) {
      alarmLevel.checked = filter
        ? !!filter.alarmLevels.find(function(selectedAlarmLevel) {
            return selectedAlarmLevel === alarmLevel.level;
          })
        : false;
      return alarmLevel;
    });

    this.alarmACKStatuses = this.alarmACKStatuses && this.alarmACKStatuses.map(alarmACKStatus => {
      alarmACKStatus.checked =
        filter && filter.alarmACKStatuses
          ? !!filter.alarmACKStatuses.find(function(selectedACKStatus) {
              return selectedACKStatus === alarmACKStatus.background;
            })
          : false;
      return alarmACKStatus;
    });

    this.trainTypes = filter.trainTypes ? this.trainTypeObjects && this.trainTypeObjects.filter(trainTypeObject => {
      return !!filter.trainTypes.find(trainType => trainType === trainTypeObject.name)
    }).map(trainType => trainType.name) : [];
  }

  preprocessFilters() {
    let filter = {
      autoRefresh: this.autoRefresh,
      alarmKeyword: this.alarmKeyword,
      alarmLevels: this.alarmLevels
        ? this.alarmLevels
            .filter(function(alarmLevel) {
              return alarmLevel.checked;
            })
            .map(function(alarmLevel) {
              return alarmLevel.level;
            })
        : [],
      alarmACKStatuses: this.alarmACKStatuses
        && this.alarmACKStatuses
            .filter((alarmStatus) => {
              return alarmStatus.checked;
            })
            .map((alarmStatus) => {
              return alarmStatus.background;
            }),
      maintainers: this.maintainers
        ? this.maintainers
            .filter(function(value) {
              return true;
            })
        : [],
      currentServiceIds: this.currentServiceIds,
      nextServiceIds: this.nextServiceIds,
      connectivityServers: this.connectivityServers
        ? this.connectivityServers
            .filter(function(value) {
              return true;
            })
        : [],
      telemetryServers: this.telemetryServers
        ? this.telemetryServers
            .filter(function(value) {
              return true;
            })
        : [],
      inCommercialServiceTrips: this.inCommercialServiceTrips,
      openedForServiceTrips: this.openedForServiceTrips,
      outsideDepot: this.outsideDepot,
      trainTypes: this.trainTypes
        ? this.trainTypes.map(trainType => {
            return trainType;
          })
        : undefined,
      showOfflineScheduledTrains: this.filtersConfig.showOfflineScheduledTrains
    };
    localStorage.setItem(
      `monitoring-filters-${this.projectId}`,
      JSON.stringify(filter)
    );
    return filter;
  }

  ngOnDestroy(): void {
    this.monitoringDataSubscription.unsubscribe();
  }
}
